export default __webpack_public_path__ + "static/handsome-creative-ATLC-print-refresh-8d014222f10f04684c2df29cfeea92ca.jpg";